import React from 'react';
import Table from 'src/components/table/Table';

const Render = ({
  transactionsModalClass,
  transactionsDisplay,
  handleClose,
  agentTransactions
}) => {

  return (
    <div
      className={`modal fade ${transactionsModalClass}`}
      id="authAlert"
      style={{
        display: transactionsDisplay,
        overflowY: "scroll",
        opacity: "1",
        background: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
        <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Transaction Details
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          <div className="modal-header d-flex justify-content-between align-items-center">
            <Table
              recordsPerPage={50}
              columns={{
                group: [
                  {
                    display: "Date",
                    // type: Date,
                    path: "date",
                    // format: DATE_TIME_FORMAT.DATE,
                  },
                  {
                    display: "Amount",
                    path: "amount",
                  },
                  {
                    display: 'Case Id',
                    path: 'case_id'
                  },
                  {
                    display: "Transaction/Ref. No",
                    path: "payment_no",
                  }
                ],
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const TransactionsPopup = ({ agentTransactions, transactionsModalClass, transactionsDisplay, onClose }) => {
  return (
    <Render
      agentTransactions={agentTransactions}
      transactionsModalClass={transactionsModalClass}
      transactionsDisplay={transactionsDisplay}
      handleClose={onClose}
    />
  );
};

export default TransactionsPopup;
